import { useToggle } from "react-use"

import { genderedMaritalStatus } from "modules/PsyProfile/common/utils"
import style from "modules/PsyProfile/components/AboutMe/components/AboutText/style.module.scss"
import { Psychologist } from "utils/interfaces"
import { Text } from "ui-kit/components-branded/Text"
import { getVisibleParagraphsCount } from "utils/helpers"

export function AboutText({ psy }: { psy: Psychologist }) {
    const [open, toggleOpen] = useToggle(false)

    const paragraphs = psy.about.split("\n").filter((str) => !!str.trim())
    const visibleParagraphsCount = getVisibleParagraphsCount(psy.about, 200)
    const collapsible = paragraphs.length > visibleParagraphsCount
    const currentParagraphs = open ? paragraphs : paragraphs.slice(0, visibleParagraphsCount)
    const showFamilyBlock = psy.marital_status || psy.has_children !== null

    return (
        <div className={style.container}>
            <div className={style.paragraphs}>
                {currentParagraphs.map((item) => (
                    <Text key={item}>{item}</Text>
                ))}
                {(!collapsible || (collapsible && open)) && showFamilyBlock && (
                    <>
                        {psy.marital_status && (
                            <span className={style.moreInfo}>
                                <Text isAccent>Семейное положение:</Text>&nbsp;
                                <Text>{genderedMaritalStatus(psy.marital_status, psy.sex)}</Text>
                            </span>
                        )}
                        {psy.has_children && (
                            <span className={style.moreInfo}>
                                <Text isAccent>Дети:</Text>&nbsp;
                                <Text>{psy.has_children ? "есть" : "нет"}</Text>
                            </span>
                        )}
                    </>
                )}
            </div>
            {collapsible && (
                <Text
                    isAccent
                    className={style.showMore}
                    onClick={toggleOpen}
                    data-testid={
                        open ? "psy-profile-about-test-close" : "psy-profile-about-test-more"
                    }
                >
                    {open ? "Свернуть" : "Читать дальше"}
                </Text>
            )}
        </div>
    )
}
